module.exports = "/img/_/_/_/assets/images/avatar/full_right/male//elf.jpg?ad2d1fcbed7d2f2011a814e0951e56dd";